import { createBrowserRouter } from "react-router-dom";
import { RootLayout } from "./components/RootLayout";
import { Welcome } from "./routes/Welcome";
import { Survey } from "./routes/Survey";
import { Done } from "./routes/Done";
import { Admin } from "./routes/Admin";
import { Timeline } from "./routes/Timeline";
import { NotFound } from "./routes/NotFound";

export const router = createBrowserRouter([
  {
    element: <RootLayout />,
    errorElement: <NotFound />,
    children: [
      { path: "/", element: <Welcome /> },
      { path: "/survey", element: <Survey /> },
      { path: "/done", element: <Done /> },
      { path: "/admin", element: <Admin /> },
      { path: "/timeline", element: <Timeline /> },
      { path: "*", element: <NotFound /> },
    ],
  },
]);
